import React from "react";
import { useTranslation } from "react-i18next";
import Heading from "../../../Components/Heading/Heading";
import TryFreeCTA from "../../../Components/TryFreeCTA/TryFreeCTA";
import styles from "./About.module.css";
import icon1 from "../../../assets/timeIcon.png";
import icon2 from "../../../assets/mobileIcon.png";
import icon3 from "../../../assets/tradingIcon.png";
import SubHeading from "../../../Components/SubHeading/SubHeading";
import { TEMP_CRM_PIVOT } from "../../../config/tempCrmPivot";

const About = () => {
  const { t } = useTranslation();
  const p = TEMP_CRM_PIVOT ? "tempPivot.about" : "about";

  return (
    <div className="container my-4 pt-5" id="about"
      data-aos="fade-up"
      data-aos-duration="500">
      <section className="text-center pt-5">
        <Heading text={t(`${p}.heading`)} />
        <p className={styles.para}>
          {t(`${p}.paragraph`)}
        </p>
      </section>
      <section className={styles.child2}>
        <div>
          <img src={icon1} width="100%" alt="" />
          <SubHeading text={t(TEMP_CRM_PIVOT ? `${p}.pillar1` : `${p}.anytimeAnywhere`)} />
        </div>
        <div>
          <img src={icon2} width="100%" alt="" />
          <SubHeading text={t("about.easyToUse")} />
        </div>
        <div>
          <img src={icon3} width="100%" alt="" />
          <SubHeading text={t("about.growsYourBusiness")} />
        </div>
      </section>
      <TryFreeCTA section="about" />
    </div>
  );
};

export default About;
